<template>
  <div v-if="option">
    <md-field class="option-select">
      <md-select
        v-model="option.selected_value"
        md-dense
        @md-selected="optionChanged"
      >
        <!-- <md-option value="" selected>Choose a value&hellip;</md-option> -->
        <md-option v-for="value in optionValues" :key="value" :value="value">{{
          value
        }}</md-option>
      </md-select>
    </md-field>
  </div>
  <div v-else>
    <p>No Option</p>
  </div>
</template>

<script>
export default {
  name: "ExtraOptionSelect",

  props: ["option"],

  computed: {
    optionValues() {
      return this.option.option.values.split("|").map(item => item.trim());
    }
  },

  data() {
    return {
      selectedValue: ""
    };
  },

  methods: {
    optionChanged(el) {
      this.$emit("optionChanged");
    }
  }
};
</script>

<style lang="scss" scoped>
.option-select {
  margin-top: 0px;
}
</style>
